import { CLEAR_FINANCIALS } from '../action-types';

const clearFinancials = () => ({
  type: CLEAR_FINANCIALS,
});

export default clearFinancials;
